import { createNode } from '@glueapp/graph-types';

export const Tangent = createNode({
    id: 'Tangent',
    name: 'Tangent',
    description: 'Gives the tangent of the value',
    aiDescription:
        'Computes the tangent of a number (in radians). Connect a value to the "Value" input port; the "Result" output port provides the tangent.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.tan(input.inPorts.Value) } };
    },
});
